import { FC, ReactNode, useState } from 'react';
import AnimateHeight from 'react-animate-height';

interface Props {
  header: (open: boolean) => ReactNode;
  children: ReactNode;
}

export const Collapse: FC<Props> = ({ header, children }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  return (
    <div>
      <a className="cursor-pointer" onClick={toggle}>
        {header(open)}
      </a>
      <AnimateHeight height={open ? 'auto' : 0} duration={300}>
        {children}
      </AnimateHeight>
    </div>
  );
};
